import ReactTip from './components';
export default ReactTip;
